module.exports = __webpack_public_path__ + "img/yy.d6ad3737.jpg";